export class FinishingEvent {
    constructor({ transfer, finishingDate }) {
        this.name = 'finishing';
        this.transfer = { ...transfer };
        this.finishingDate = finishingDate;
    }
    get data() {
        return {
            transfer: this.transfer,
            finishingDate: this.finishingDate,
        };
    }
}
